<template>
  <div>
    <CRow>
      <CCol col="12">
        <JobList/>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import JobList from '../../components/supervisor/JobList'

export default {
  name: 'JobTypeManagement',
  components: {
    JobList
  },
}
</script>